import "./RealEstate.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StrategicCommercialization from "./sections/StrategicCommercialization";
import InvestorInsights from "./sections/InvestorInsights";
import FooterLegal from "@/reusable_sections/Footer";
import Gallery from "./sections/Gallery";
export default function RealEstatePage() {
  return <div>
      <MainNavigation />
      <Gallery />
      <StrategicCommercialization />
      <InvestorInsights />
      <FooterLegal />
    </div>;
}